package com.evoapps.evoshift.ui.user

import com.evoapps.evoshift.ui.util.currentMonthNumber
import com.evoapps.evoshift.ui.util.inMonth
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import androidx.compose.animation.AnimatedContent
import androidx.compose.animation.animateColorAsState
import androidx.compose.animation.core.animateFloatAsState
import androidx.compose.foundation.LocalIndication
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.remember
import com.evoapps.evoshift.ui.theme.LocalReducedMotion
import com.evoapps.evoshift.ui.theme.Motion
import com.evoapps.evoshift.ui.theme.MotionVisibility
import com.evoapps.evoshift.ui.theme.motionTween
import com.evoapps.evoshift.ui.theme.pressScale
import com.evoapps.evoshift.ui.theme.rememberLastNonNull
import com.evoapps.evoshift.ui.theme.swapUp
import com.evoapps.evoshift.ui.util.UiText
import com.evoapps.evoshift.widgets.LocalActionFeedback
import com.evoapps.evoshift.widgets.LocalOnColours
import kotlinx.coroutines.flow.Flow

import androidx.compose.material3.TextButton
import evoshift.composeapp.generated.resources.clock_without_shift_explained
import evoshift.composeapp.generated.resources.clock_without_shift
import evoshift.composeapp.generated.resources.break_end
import evoshift.composeapp.generated.resources.break_start
import evoshift.composeapp.generated.resources.clock_on_break_since
import androidx.compose.material3.OutlinedButton
import androidx.compose.ui.platform.testTag
import androidx.compose.material.icons.filled.FreeBreakfast
import com.evoapps.evoshift.domain.market.payroll.MonthPayFactors
import com.evoapps.evoshift.ui.finance.payFactorLines
import com.evoapps.evoshift.ui.finance.payFactorNotes
import com.evoapps.evoshift.widgets.EvoTopBar
import com.evoapps.evoshift.widgets.TopBarAction
import com.evoapps.evoshift.widgets.helpAction
import com.evoapps.evoshift.ui.notifications.notificationsAction
import com.evoapps.evoshift.ui.util.HelpCentreButton
import com.evoapps.evoshift.ui.util.HelpPage
import com.evoapps.evoshift.ui.finance.formatMoney
import evoshift.composeapp.generated.resources.dashboard_take_home
import evoshift.composeapp.generated.resources.dashboard_pay_estimate_note
import evoshift.composeapp.generated.resources.clock_idle
import evoshift.composeapp.generated.resources.clock_working_since
import evoshift.composeapp.generated.resources.clock_shift_window
import evoshift.composeapp.generated.resources.clock_done_label
import evoshift.composeapp.generated.resources.clock_done
import evoshift.composeapp.generated.resources.clock_out
import androidx.compose.material.icons.filled.CheckCircle
import androidx.compose.foundation.border
import com.evoapps.evoshift.ui.util.asString
import com.evoapps.evoshift.domain.usecase.shift.ClockStatus
import com.evoapps.evoshift.ui.notifications.LocalOpenNotifications
import com.evoapps.evoshift.ui.notifications.NotificationsBell
import com.evoapps.evoshift.ui.adaptive.contentWidth
import com.evoapps.evoshift.ui.adaptive.PostureAwareScaffold
import com.evoapps.evoshift.ui.adaptive.LocalWindowWidthClass
import com.evoapps.evoshift.ui.adaptive.DashboardColumns
import com.evoapps.evoshift.ui.adaptive.handCursor
import com.evoapps.evoshift.ui.kiosk.ScanTabletCodeButton
import com.evoapps.evoshift.ui.adaptive.hoverLift
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.ArrowDropDown
import androidx.compose.material.icons.filled.Notifications
import androidx.compose.material.icons.filled.Person
import androidx.compose.material.icons.filled.Schedule
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Scaffold
import androidx.compose.material3.Text
import androidx.compose.material3.TopAppBar
import androidx.compose.material3.TopAppBarDefaults
import androidx.compose.runtime.Composable
import com.evoapps.evoshift.domain.model.Adjustment
import com.evoapps.evoshift.ui.finance.adjustmentTypeLabel
import com.evoapps.evoshift.ui.finance.signedAdjustmentAmount
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import com.evoapps.evoshift.ui.Cream
import com.evoapps.evoshift.ui.DeepNavy
import com.evoapps.evoshift.ui.GoldMetallicBrush
import com.evoapps.evoshift.viewmodels.EmployeeDashboardViewModel
import com.evoapps.evoshift.widgets.LoadingSwap
import com.evoapps.evoshift.widgets.SkeletonCard
import com.evoapps.evoshift.widgets.RegularCard
import com.evoapps.evoshift.widgets.StandoutCard
import evoshift.composeapp.generated.resources.Res
import evoshift.composeapp.generated.resources.dashboard_action_inbox
import evoshift.composeapp.generated.resources.dashboard_clock_in
import evoshift.composeapp.generated.resources.dashboard_estimated_earnings
import evoshift.composeapp.generated.resources.dashboard_no_messages
import evoshift.composeapp.generated.resources.dashboard_notifications
import evoshift.composeapp.generated.resources.dashboard_profile
import evoshift.composeapp.generated.resources.dashboard_select_workplace
import evoshift.composeapp.generated.resources.dashboard_unread_messages
import org.jetbrains.compose.resources.pluralStringResource
import evoshift.composeapp.generated.resources.dashboard_workplace_switch
import org.jetbrains.compose.resources.stringResource
import com.evoapps.evoshift.location.rememberLocationReader

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun EmployeeDashboardScreen(
    viewModel: EmployeeDashboardViewModel,
    onNavigateToProfile: () -> Unit,
    onNavigateToMyShifts: () -> Unit,
    onNavigateToMarketplace: () -> Unit,
    onSwitchWorkplaceClicked: () -> Unit,
    /** SH-121: the person's checklists today, under the next shift. */
    myChecklists: @Composable () -> Unit = {},
    /** SH-170: "Do zrobienia" at the top (availability, the next shift, swaps, policies, the marketplace). */
    todo: @Composable () -> Unit = {},
) {
    val state by viewModel.uiState.collectAsStateWithLifecycle()
    // SH-106: read once at the tap where the workplace checks the location.
    val readLocation = rememberLocationReader()
    if (state.locationNotice) LocationNoticeDialog(viewModel::onLocationNoticeAnswered)
    // SH-158: the clock's answer in the hand.
    ClockResultFeedback(viewModel.clockResults)
    // SH-165: a clock-out well before the planned end is asked about; each one offers Undo.
    state.earlyClockOut?.let { end -> EarlyClockOutDialog(end, viewModel::onEarlyClockOutAnswered) }
    val clockSnackbar = androidx.compose.runtime.remember { androidx.compose.material3.SnackbarHostState() }
    ClockOutUndoSnackbar(state.clockOutUndo, clockSnackbar, viewModel::onUndoClockOut, viewModel::dismissClockOutUndo)

    Scaffold(
        containerColor = Cream,
        snackbarHost = { androidx.compose.material3.SnackbarHost(clockSnackbar) },
        topBar = {
            EvoTopBar(
                showWorkplace = true,
                showMonth = true,
                actions = listOf(
                    helpAction(HelpPage.EMPLOYEE_GUIDE),
                    notificationsAction(),
                    TopBarAction(stringResource(Res.string.dashboard_profile), Icons.Default.Person, onNavigateToProfile, collapsible = false)
                )
            )
        },
    ) { padding ->
        // SH-130: the columns below scroll across the whole screen and centre their content.
        val maxWidth = LocalWindowWidthClass.current.wideContentMaxWidth
        Box(
            modifier = Modifier
                .fillMaxSize()
                .padding(padding)
        ) {
            // SH-247: the cards' placeholders until the dashboard is known (switching workplace keeps
            // the old one until the new arrives).
            val known = state.dashboardData != null || !state.isLoading
            val nextShift: @Composable () -> Unit = {
                LoadingSwap(known = known, placeholder = { NextShiftPlaceholder() }) {
                    NextShiftCard(
                        shift = state.dashboardData?.nextShift,
                        workplaceName = state.workplaceName,
                        onClick = onNavigateToMyShifts,
                        modifier = Modifier.hoverLift()
                    )
                }
                myChecklists()
            }

            // The month the figures are for: the dashboard may show the next or latest roster (SH-28).
            val rosterMonth = state.dashboardData?.month?.takeIf { it in 1..12 }
            val earningsMonth = inMonth(rosterMonth ?: currentMonthNumber())
            val earnings: @Composable () -> Unit = {
                // An owner whose shifts are unpaid has no earnings here (SH-37).
                if (state.dashboardData?.isPaid != false) LoadingSwap(known = known, placeholder = { FigurePlaceholder() }) { EstimatedEarningsCard(
                    title = stringResource(Res.string.dashboard_estimated_earnings, earningsMonth),
                    gross = state.dashboardData?.monthlyEstimatedEarnings ?: 0.0,
                    net = state.dashboardData?.monthlyEstimatedNet,
                    currency = state.currency,
                    adjustments = state.dashboardData?.adjustments.orEmpty(),
                    factors = state.dashboardData?.payFactors,
                    onClick = onNavigateToMyShifts,
                    modifier = Modifier.hoverLift()
                ) }
            }

            val unread = state.dashboardData?.unreadNotifications ?: 0
            val inboxContent = if (unread > 0) pluralStringResource(
                Res.plurals.dashboard_unread_messages,
                unread,
                unread
            ) else stringResource(Res.string.dashboard_no_messages)
            val inbox: @Composable () -> Unit = {
                LoadingSwap(
                    known = known,
                    placeholder = { SkeletonCard(lines = 1, title = stringResource(Res.string.dashboard_action_inbox)) }
                ) {
                    InfoCard(
                        title = stringResource(Res.string.dashboard_action_inbox),
                        content = inboxContent,
                        onClick = LocalOpenNotifications.current,
                        modifier = Modifier.hoverLift()
                    )
                }
            }

            val clock: @Composable () -> Unit = {
                ClockInButton(
                    status = state.clock,
                    busy = state.clockBusy,
                    onClick = { viewModel.onClockClicked(readLocation) }
                )
                // SH-116: while working, start or end a break.
                BreakButton(status = state.clock, busy = state.clockBusy, onClick = { viewModel.onBreakClicked(readLocation) })
                ClockNote(state.clockNote, viewModel::clearClockNote)
                // The breaks registered on today's shift.
                when (val c = state.clock) {
                    is ClockStatus.Working -> MyBreaksList(c.shift.breaks, textColor = DeepNavy)
                    is ClockStatus.Done -> MyBreaksList(c.shift.breaks, textColor = DeepNavy)
                    else -> {}
                }
                // SH-134: no shift now (covering for someone, called in): a manager confirms it.
                ClockWithoutShiftButton(
                    visible = state.clock is ClockStatus.Idle || state.clock is ClockStatus.Done,
                    busy = state.clockBusy,
                    onClick = { viewModel.onClockWithoutShift(readLocation) }
                )
                // SH-111: or scan the code on the workplace's tablet to clock in or out (SH-134: also
                // without a shift); breaks use the break button above, no tablet needed.
                ScanTabletCodeButton(
                    visible = state.clock !is ClockStatus.Done,
                    modifier = Modifier.padding(top = 8.dp)
                )
                ClockError(state.error, viewModel::clearError)
            }

            // SH-102: on a foldable the next shift and the money sit above the hinge (or on the
            // left of a flat, nearly square display) and the clock below it, a steady base to tap.
            PostureAwareScaffold(
                controls = {
                    Column(
                        modifier = Modifier.fillMaxSize().verticalScroll(rememberScrollState()).contentWidth(maxWidth).padding(24.dp),
                        verticalArrangement = Arrangement.spacedBy(16.dp, Alignment.CenterVertically),
                        horizontalAlignment = Alignment.CenterHorizontally
                    ) {
                        clock()
                    }
                },
                content = {
                    Column(
                        modifier = Modifier
                            .fillMaxSize()
                            .verticalScroll(rememberScrollState())
                            .contentWidth(maxWidth)
                            .padding(horizontal = 16.dp),
                        verticalArrangement = Arrangement.spacedBy(16.dp),
                        horizontalAlignment = Alignment.CenterHorizontally
                    ) {
                        Spacer(modifier = Modifier.height(8.dp))
                        todo()
                        nextShift()
                        earnings()
                        inbox()
                        Spacer(modifier = Modifier.height(16.dp))
                    }
                },
                normal = {
                    Column(
                        modifier = Modifier
                            .fillMaxSize()
                            .verticalScroll(rememberScrollState())
                            .contentWidth(maxWidth)
                            .padding(horizontal = 16.dp),
                        verticalArrangement = Arrangement.spacedBy(16.dp),
                        horizontalAlignment = Alignment.CenterHorizontally
                    ) {
                        Spacer(modifier = Modifier.height(8.dp))

                        if (LocalWindowWidthClass.current.isCompact) {
                            todo()
                            nextShift()
                            earnings()
                            inbox()
                            Spacer(modifier = Modifier.height(24.dp))
                            clock()
                        } else {
                            // SH-105: wide windows read across: today (the next shift and the clock in
                            // its own panel, so the big button does not float alone) on the left, the
                            // month's money and the messages on the right.
                            val clockPanel: @Composable () -> Unit = {
                                RegularCard(Modifier.fillMaxWidth()) {
                                    Column(
                                        modifier = Modifier.fillMaxWidth().padding(24.dp),
                                        verticalArrangement = Arrangement.spacedBy(16.dp),
                                        horizontalAlignment = Alignment.CenterHorizontally
                                    ) {
                                        clock()
                                    }
                                }
                            }
                            DashboardColumns(listOf(listOf(todo, nextShift, clockPanel), listOf(earnings, inbox)))
                        }

                        Spacer(modifier = Modifier.height(48.dp))
                    }
                }
            )

            // SH-247: no spinner over the dashboard: the cards show their placeholders until it is known.
        }
    }
}

@Composable
fun EstimatedEarningsCard(
    title: String,
    gross: Double,
    net: Double?,
    currency: String,
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
    /** The person's own bonuses, deductions and refunds of the month (SH-78), already in the figures. */
    adjustments: List<Adjustment> = emptyList(),
    /** SH-57: overtime, Sunday and holiday work and the minimum-wage top-up, already in the figures. */
    factors: MonthPayFactors? = null
) {
    StandoutCard(
        modifier = modifier.fillMaxWidth(),
        onClick = onClick
    ) {
        Column(modifier = Modifier.padding(24.dp)) {
            Text(
                text = title,
                style = MaterialTheme.typography.titleMedium.copy(
                    fontWeight = FontWeight.Bold
                ),
                color = LocalOnColours.current.accent
            )
            Spacer(modifier = Modifier.height(8.dp))
            // Take-home pay first: that is what people plan with; the gross underneath.
            // SH-158: a new figure (a shift worked, a bonus) rolls in instead of popping.
            com.evoapps.evoshift.ui.theme.AnimatedAmountText(
                text = formatMoney(net ?: gross, currency),
                style = MaterialTheme.typography.displaySmall.copy(
                    fontWeight = FontWeight.Bold
                ),
                color = LocalOnColours.current.onSurface
            )
            if (net != null) {
                Text(
                    text = stringResource(Res.string.dashboard_take_home, formatMoney(gross, currency)),
                    style = MaterialTheme.typography.bodyMedium,
                    color = LocalOnColours.current.onSurfaceVariant
                )
            }
            // SH-57: overtime, Sunday and holiday work, the minimum-wage top-up, sick pay, holiday pay
            // and a pay change during the month on their own lines, each an estimate.
            factors?.let { f ->
                payFactorLines(f, currency).forEach { (label, amount) ->
                    Row(Modifier.fillMaxWidth().padding(top = 4.dp), verticalAlignment = Alignment.CenterVertically) {
                        Text(
                            text = label,
                            style = MaterialTheme.typography.bodySmall,
                            color = LocalOnColours.current.onSurfaceVariant,
                            modifier = Modifier.weight(1f)
                        )
                        Text(
                            // What the month takes off (a salary's sick days) comes signed already.
                            text = if (amount.startsWith("−")) amount else "+$amount",
                            style = MaterialTheme.typography.bodySmall,
                            fontWeight = FontWeight.SemiBold,
                            color = LocalOnColours.current.onSurface
                        )
                    }
                }
                payFactorNotes(f, currency).forEach { note ->
                    Text(
                        text = note,
                        style = MaterialTheme.typography.bodySmall,
                        color = LocalOnColours.current.onSurfaceVariant,
                        modifier = Modifier.padding(top = 4.dp)
                    )
                }
            }
            // SH-78: each bonus, deduction and refund on its own line.
            adjustments.forEach { adjustment ->
                Row(Modifier.fillMaxWidth().padding(top = 4.dp), verticalAlignment = Alignment.CenterVertically) {
                    Text(
                        text = "${adjustmentTypeLabel(adjustment.type)} · ${adjustment.description}",
                        style = MaterialTheme.typography.bodySmall,
                        color = LocalOnColours.current.onSurfaceVariant,
                        modifier = Modifier.weight(1f)
                    )
                    Text(
                        text = signedAdjustmentAmount(adjustment, currency),
                        style = MaterialTheme.typography.bodySmall,
                        fontWeight = FontWeight.SemiBold,
                        color = LocalOnColours.current.onSurface
                    )
                }
            }
            // An estimate, never a payslip (SH-56): the employer's own pay run decides the amount.
            Spacer(modifier = Modifier.height(8.dp))
            Text(
                text = stringResource(Res.string.dashboard_pay_estimate_note),
                style = MaterialTheme.typography.bodySmall,
                color = LocalOnColours.current.onSurfaceVariant
            )
        }
    }
}

@Composable
fun InfoCard(
    title: String,
    content: String,
    onClick: () -> Unit,
    modifier: Modifier = Modifier
) {
    RegularCard(
        onClick = onClick,
        modifier = modifier.fillMaxWidth()
    ) {
        Column(modifier = Modifier.padding(24.dp)) {
            Text(
                text = title,
                style = MaterialTheme.typography.titleMedium.copy(
                    fontWeight = FontWeight.Bold
                ),
                color = DeepNavy.copy(alpha = 0.7f)
            )
            Spacer(modifier = Modifier.height(8.dp))
            Text(
                text = content,
                style = MaterialTheme.typography.bodyLarge.copy(
                    fontWeight = FontWeight.Medium
                ),
                color = DeepNavy
            )
        }
    }
}

/** Test tag of "Clock in without a scheduled shift" (SH-134). */
const val CLOCK_WITHOUT_SHIFT_TAG = "clock_without_shift"

/** SH-158: test tag of the ring that turns around the clock button while a tap is on its way. */
const val CLOCK_BUSY_TAG = "clock_busy"

/** SH-134: clocking in with no shift of one's own now; a manager confirms it. */
@Composable
fun ClockWithoutShiftButton(visible: Boolean, busy: Boolean, onClick: () -> Unit) {
    MotionVisibility(visible) {
        Column(horizontalAlignment = Alignment.CenterHorizontally, modifier = Modifier.padding(top = 8.dp)) {
            TextButton(onClick = onClick, enabled = !busy, modifier = Modifier.handCursor().testTag(CLOCK_WITHOUT_SHIFT_TAG)) {
                Text(stringResource(Res.string.clock_without_shift), color = DeepNavy, fontWeight = FontWeight.Bold)
            }
            Text(
                stringResource(Res.string.clock_without_shift_explained),
                style = MaterialTheme.typography.bodySmall,
                color = DeepNavy.copy(alpha = 0.7f),
                textAlign = TextAlign.Center
            )
        }
    }
}

/** Test tag of the break button (SH-116). */
const val BREAK_BUTTON_TAG = "break_button"

/**
 * SH-116: under the clock while working: "Start break", or "End break" during one. The clock
 * button itself still ends the shift (a break going on ends with it). SH-158: it unfolds when
 * the shift starts and folds away when it ends; its label swaps in place.
 */
@Composable
fun BreakButton(status: ClockStatus, busy: Boolean, onClick: () -> Unit) {
    val working = status as? ClockStatus.Working
    val onBreak = rememberLastNonNull(working?.onBreak) ?: false
    val reduced = LocalReducedMotion.current
    MotionVisibility(working != null) {
        OutlinedButton(
            onClick = onClick,
            enabled = !busy && working != null,
            modifier = Modifier.padding(top = 8.dp).handCursor().testTag(BREAK_BUTTON_TAG)
        ) {
            Icon(Icons.Default.FreeBreakfast, contentDescription = null, tint = DeepNavy)
            Spacer(Modifier.width(8.dp))
            AnimatedContent(targetState = onBreak, transitionSpec = { swapUp(reduced) }, label = "breakLabel") { during ->
                Text(stringResource(if (during) Res.string.break_end else Res.string.break_start), color = DeepNavy)
            }
        }
    }
}

/** SH-158: the clock's answer in the hand: a confirming buzz when it worked, a refusing one when not. */
@Composable
fun ClockResultFeedback(results: Flow<Boolean>) {
    val feedback = LocalActionFeedback.current
    LaunchedEffect(results, feedback) {
        results.collect { done -> if (done) feedback.confirm() else feedback.reject() }
    }
}

/** SH-158: the clock's error under it, folding in and out; a tap dismisses it. */
@Composable
fun ClockError(error: UiText?, onDismiss: () -> Unit) {
    val shown = rememberLastNonNull(error)
    MotionVisibility(error != null) {
        Text(
            shown?.asString().orEmpty(),
            color = MaterialTheme.colorScheme.error,
            style = MaterialTheme.typography.bodyMedium,
            textAlign = TextAlign.Center,
            modifier = Modifier.handCursor().clickable(onClick = onDismiss)
        )
    }
}

/**
 * Clock in / out. Gold and active when there is something to do (start the shift, or finish it),
 * muted otherwise; the line below says which shift and since when. SH-158: while a tap is on its
 * way the button keeps its look and a ring turns around it; the icon and label swap in place, the
 * colours blend, and the circle sinks a little under the finger.
 */
@Composable
fun ClockInButton(status: ClockStatus, busy: Boolean, onClick: () -> Unit) {
    val actionable = status is ClockStatus.CanClockIn || status is ClockStatus.Working
    val active = actionable && !busy
    val reduced = LocalReducedMotion.current
    val label = when (status) {
        is ClockStatus.Working -> stringResource(Res.string.clock_out)
        is ClockStatus.Done -> stringResource(Res.string.clock_done_label)
        else -> stringResource(Res.string.dashboard_clock_in)
    }
    val detail = when (status) {
        is ClockStatus.CanClockIn -> stringResource(
            Res.string.clock_shift_window,
            status.shift.plannedTime.start.substringAfter('T').take(5),
            status.shift.plannedTime.end.substringAfter('T').take(5)
        )
        is ClockStatus.Working -> status.breakSince?.let { stringResource(Res.string.clock_on_break_since, it) }
            ?: stringResource(Res.string.clock_working_since, status.since)
        is ClockStatus.Done -> stringResource(Res.string.clock_done, status.start, status.end)
        ClockStatus.Idle -> stringResource(Res.string.clock_idle)
    }
    val tint by animateColorAsState(if (actionable) DeepNavy else DeepNavy.copy(alpha = 0.4f), motionTween(Motion.MEDIUM_MS), label = "clockTint")
    val labelColor by animateColorAsState(if (actionable) DeepNavy else DeepNavy.copy(alpha = 0.5f), motionTween(Motion.MEDIUM_MS), label = "clockLabel")
    val border by animateColorAsState(
        if (status is ClockStatus.Working) DeepNavy else DeepNavy.copy(alpha = 0f), motionTween(Motion.MEDIUM_MS), label = "clockBorder"
    )
    val goldAlpha by animateFloatAsState(if (actionable) 1f else 0f, motionTween(Motion.MEDIUM_MS), label = "clockGold")
    val interaction = remember { MutableInteractionSource() }
    Column(horizontalAlignment = Alignment.CenterHorizontally) {
        Box(contentAlignment = Alignment.Center, modifier = Modifier.size(150.dp)) {
            Box(
                modifier = Modifier
                    .size(140.dp)
                    .pressScale(interaction)
                    .clip(CircleShape)
                    .background(DeepNavy.copy(alpha = 0.08f))
                    .background(GoldMetallicBrush, alpha = goldAlpha)
                    .border(3.dp, border, CircleShape)
                    .then(if (active) Modifier.handCursor() else Modifier)
                    .clickable(interactionSource = interaction, indication = LocalIndication.current, enabled = active, onClick = onClick),
                contentAlignment = Alignment.Center
            ) {
                AnimatedContent(
                    targetState = ClockFace(done = status is ClockStatus.Done, label = label),
                    transitionSpec = { swapUp(reduced) },
                    contentAlignment = Alignment.Center,
                    label = "clockFace"
                ) { face ->
                    Column(horizontalAlignment = Alignment.CenterHorizontally) {
                        Icon(
                            imageVector = if (face.done) Icons.Default.CheckCircle else Icons.Default.Schedule,
                            contentDescription = null,
                            modifier = Modifier.size(48.dp),
                            tint = tint
                        )
                        Spacer(modifier = Modifier.height(8.dp))
                        // Two words in a 140dp circle: a smaller, centred label that may wrap once.
                        Text(
                            text = face.label,
                            style = MaterialTheme.typography.labelLarge.copy(fontWeight = FontWeight.Bold),
                            color = labelColor,
                            textAlign = TextAlign.Center,
                            maxLines = 2,
                            modifier = Modifier.padding(horizontal = 16.dp)
                        )
                    }
                }
            }
            // While the tap is on its way: the button stays as it was and a ring turns around it.
            if (busy && actionable) {
                CircularProgressIndicator(
                    modifier = Modifier.size(150.dp).testTag(CLOCK_BUSY_TAG),
                    color = DeepNavy,
                    strokeWidth = 3.dp
                )
            }
        }
        Spacer(Modifier.height(4.dp))
        AnimatedContent(targetState = detail, transitionSpec = { swapUp(reduced) }, label = "clockDetail") { shown ->
            Text(shown, style = MaterialTheme.typography.bodyMedium, color = DeepNavy.copy(alpha = 0.7f), textAlign = TextAlign.Center)
        }
    }
}

/** What the clock's face shows: the icon (done or not) and the label. */
private data class ClockFace(val done: Boolean, val label: String)
